(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["subscription-purchase-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('subscription-purchase-card')) {
    customElements.define('subscription-purchase-card', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.form = this.querySelector('form');
        this.labels = JSON.parse(this.querySelector('[data-card-labels]').textContent);
        this.purpose = 'self';
        this.step = 'choice';
        this.pending = false;
        this.find = selector => this.querySelector(selector);
        this.formatter = new Intl.NumberFormat(this.dataset.locale, { style: 'currency', currency: this.dataset.currency, minimumFractionDigits: 0, maximumFractionDigits: 2 });
        this.fractionalFormatter = new Intl.NumberFormat(this.dataset.locale, { style: 'currency', currency: this.dataset.currency, minimumFractionDigits: 2, maximumFractionDigits: 2 });
        this.querySelectorAll('[data-card-money]').forEach(el => { el.textContent = this.money(Number(el.dataset.cardMoney)); });
        const purposeControl = this.find('[data-card-purpose]');
        if (purposeControl) purposeControl.hidden = false;
        this.addEventListener('change', event => {
          if (this.pending) return;
          if (event.target.matches('[data-card-purpose-input]')) this.purpose = event.target.value;
          this.sync();
        });
        this.addEventListener('input', event => {
          if (event.target.matches('[data-card-recipient], [data-card-message]')) this.personalize();
        });
        this.find('[data-card-back]')?.addEventListener('click', () => {
          if (this.pending) return;
          this.step = 'choice';
          this.sync();
          this.find('[data-card-purpose-input]:checked')?.focus({ preventScroll: true });
          this.find('[data-subscription-toggle]').scrollIntoView({ block: 'start' });
        });
        this.form.addEventListener('submit', event => this.submit(event));
        this.sync();
        window.addEventListener('pageshow', () => { if (this.isConnected && this.pending) this.setPending(false); });
      }
      money(cents) { return (cents % 100 === 0 ? this.formatter : this.fractionalFormatter).format(cents / 100); }
      personalize() {
        const name = this.find('[data-card-recipient]')?.value.trim() || '';
        const message = this.find('[data-card-message]')?.value.trim() || '';
        const nameOutput = this.find('[data-card-preview-name]');
        const messageOutput = this.find('[data-card-preview-message]');
        if (nameOutput) { nameOutput.hidden = !name; nameOutput.textContent = name; }
        if (messageOutput) { messageOutput.hidden = !message; messageOutput.textContent = message; }
      }
      sync() {
        const selected = this.find('[data-card-variant]:checked');
        const available = selected && !selected.disabled;
        const count = Number(selected?.dataset.count || 0);
        const price = Number(selected?.dataset.price || 0);
        const original = Number(selected?.dataset.original || 0);
        const gift = this.purpose === 'gift';
        this.find('[data-card-purpose-property]').value = this.purpose;
        this.find('[data-card-count-property]').value = count || '';
        this.find('[data-card-count-property]').disabled = !count;
        if (this.totalPrice !== price) {
          const total = this.find('[data-card-total]');
          const formattedPrice = this.money(price);
          if (this.totalPrice !== undefined && typeof window.sbAnimateMoney === 'function') {
            window.sbAnimateMoney(total, formattedPrice);
          } else {
            total.textContent = formattedPrice;
          }
          this.find('[data-card-total-announcement]').textContent = formattedPrice;
          this.totalPrice = price;
        }
        this.find('[data-card-total-label]').textContent = count ? this.labels.total.replace('__count__', count) : this.labels.total.replace('__count__', '—');
        this.find('[data-card-original]').textContent = this.money(original);
        this.find('[data-card-original]').hidden = !(original > price);
        this.find('[data-card-saving]').hidden = !(original > price);
        this.find('[data-card-saving-value]').textContent = this.money(Math.max(0, original - price));
        this.find('[data-card-choice-step]').hidden = this.step !== 'choice';
        const giftStep = this.find('[data-card-gift-step]');
        if (giftStep) giftStep.hidden = this.step !== 'gift';
        this.querySelectorAll('[data-card-recipient], [data-card-message]').forEach(input => { input.disabled = !gift; });
        const note = this.find('[data-card-purpose-note]');
        if (note) note.textContent = gift ? this.labels.giftNote : this.labels.selfNote;
        this.find('[data-card-personal]').textContent = gift ? this.labels.giftTerms : this.labels.selfTerms;
        const previewCount = this.find('[data-card-preview-count]');
        if (previewCount) previewCount.textContent = this.labels.sessions.replace('__count__', count);
        this.find('[data-card-submit]').disabled = !available;
        this.find('[data-card-submit-label]').textContent = !available ? this.labels.unavailable : gift ? (this.step === 'gift' ? this.labels.submitGift : this.labels.gift) : this.labels.self;
        this.personalize();
      }
      setPending(pending) {
        this.pending = pending;
        this.form.setAttribute('aria-busy', String(pending));
        if (pending) {
          this.previousDisabled = new Map();
          this.form.querySelectorAll('button, input, textarea').forEach(el => { this.previousDisabled.set(el, el.disabled); el.disabled = true; });
          this.find('[data-card-submit-label]').textContent = this.labels.busy;
        } else {
          this.previousDisabled?.forEach((disabled, el) => { el.disabled = disabled; });
          this.sync();
        }
      }
      async submit(event) {
        event.preventDefault();
        if (this.pending) return;
        const selected = this.find('[data-card-variant]:checked');
        if (!selected || selected.disabled) return;
        if (this.purpose === 'gift' && this.step === 'choice') {
          this.step = 'gift';
          this.sync();
          this.find('[data-card-recipient]')?.focus({ preventScroll: true });
          this.find('[data-card-gift-step]').scrollIntoView({ block: 'start' });
          return;
        }
        if (!this.form.reportValidity()) return;
        const body = new FormData(this.form);
        this.querySelectorAll('[data-card-purpose-input]').forEach(input => body.delete(input.name));
        body.set('quantity', '1');
        const errorOutput = this.find('[data-card-error]');
        const cartLink = this.find('[data-card-cart-link]');
        errorOutput.hidden = true;
        cartLink.hidden = true;
        this.setPending(true);
        let response;
        try {
          response = await fetch(this.dataset.addUrl, { method: 'POST', body, credentials: 'same-origin', headers: { Accept: 'application/json' } });
          if (!response.ok) {
            const error = await response.json().catch(() => ({}));
            const detail = typeof error.description === 'string' ? error.description : typeof error.message === 'string' ? error.message : this.labels.error;
            errorOutput.textContent = detail;
            errorOutput.hidden = false;
            this.setPending(false);
            return;
          }
          window.location.assign(this.dataset.cartUrl);
        } catch {
          errorOutput.textContent = this.labels.networkError;
          errorOutput.hidden = false;
          cartLink.hidden = false;
          this.setPending(false);
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
